<template>
  <b-modal ref="modal" :ok-disabled="loading" @ok="confirmSerialNumber">
    <template #modal-title>
      {{ $t('product-serial-number-modal.prompt.title') }}
    </template>
    <template #modal-ok>
      <b-spinner v-if="loading" small></b-spinner>
      {{ $t('product-serial-number-modal.action') }}
    </template>
    <template #modal-cancel>
      {{ $t('product-serial-number-modal.cancel') }}
    </template>

    <p>{{ $t('product-serial-number-modal.prompt.content') }}</p>
    <ul>
      <li :title="product.name" v-for="product in products" :key="product.id">
        <strong>{{ product.quantity }} x {{ product.name }}</strong>
        <b-form inline v-if="product.require_serial_number">
          <label class="mr-sm-2">
            {{ $t('product-serial-number-modal.prompt.serial') }}:
          </label>
          <b-input v-model="product.serial_number" required />
        </b-form>
      </li>
    </ul>
    <b-alert v-if="error" show variant="danger">
      {{ error }}
    </b-alert>
  </b-modal>
</template>
<script>
import axios from 'axios';
export default {
  props: {
    role: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      loading: false,
      error: null,
    };
  },
  methods: {
    show(products) {
      this.products = products;
      this.$refs.modal.show();
      this.error = null;
    },
    async confirmSerialNumber(event) {
      event.preventDefault();
      this.loading = true;
      try {
        if (this.products.some(({ serial_number }) => !serial_number)) {
          this.error = this.$t(
            'product-serial-number-modal.prompt.serial_number_missing',
          );
          this.loading = false;
          return;
        }
        await axios.post(`/data-api/job-product/bulk`, {
          products: this.products
            .filter(({ serial_number }) => serial_number)
            .map(({ id, serial_number }) => ({
              id,
              serialNumber: serial_number,
            })),
        });
        this.$emit('confirmed');
        this.$refs.modal.hide();
      } catch (error) {
        this.error = error.response.data.message;
      }
      this.loading = false;
    },
  },
};
</script>
